export const iconFontAwesomeHumanitarianTruckMedical = (
	<i className="fa-solid fa-truck-medical"></i>
);
